/*This is the normal font-awesome/all.css, hacked to work so it can be included*/
/*in a web component. Much of the content has been stripped out to reduce the*/
/*size of the file. If there is something you are missing, you can grab it form*/
/*the original file and add it here with the following changes:*/

/*Apply the styles on a :host selector. ie :host(.fa-regular)*/

/*The font faces have also been removed because they do not work from within*/
/*the shadow dom. They must be included separately. In the case of storybooks*/
/*the are added in preview-head.html. Otherwise aha-app provides the font-faces.*/

/*!
* Font Awesome Pro 6.0.0-beta3 by @fontawesome - https://fontawesome.com
* License - https://fontawesome.com/license (Commercial License)
* Copyright 2021 Fonticons, Inc.
*/

:root {
  --fa-style-family: 'Font Awesome 7 Pro';
  --fa-style: 900;
}

:host(.fa) {
  font-family: 'Font Awesome 7 Pro';
  font-family: var(--fa-style-family);
  font-weight: 900;
  font-weight: var(--fa-style);
}

:host(.fa),
:host(.fas),
:host(.fa-solid),
:host(.far),
:host(.fa-regular),
:host(.fal),
:host(.fa-light),
:host(.fat),
:host(.fa-thin),
:host(.fad),
:host(.fa-duotone),
:host(.fab),
:host(.fa-brands) {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

:host(.fa-lg) {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

:host(.fa-xs) {
  font-size: 0.75em;
}

:host(.fa-sm) {
  font-size: 0.875em;
}

:host(.fa-1x) {
  font-size: 1em;
}

:host(.fa-2x) {
  font-size: 2em;
}

:host(.fa-3x) {
  font-size: 3em;
}

:host(.fa-4x) {
  font-size: 4em;
}

:host(.fa-5x) {
  font-size: 5em;
}

:host(.fa-6x) {
  font-size: 6em;
}

:host(.fa-7x) {
  font-size: 7em;
}

:host(.fa-8x) {
  font-size: 8em;
}

:host(.fa-9x) {
  font-size: 9em;
}

:host(.fa-10x) {
  font-size: 10em;
}

:host(.fa-fw) {
  text-align: center;
  width: 1.25em;
}

:host(.fa-ul) {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.fa-ul > li {
  position: relative;
}

:host(.fa-li) {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

:host(.fa-border) {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

:host(.fa-pull-left) {
  float: left;
  margin-right: 0.3em;
}

:host(.fa-pull-right) {
  float: right;
  margin-left: 0.3em;
}

:host(.fa-spin) {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}

:host(.fa-pulse) {
  -webkit-animation: fa-spin 1s infinite steps(8);
  animation: fa-spin 1s infinite steps(8);
}

@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

:host(.fa-rotate-90) {
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

:host(.fa-rotate-180) {
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

:host(.fa-rotate-270) {
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

:host(.fa-flip-horizontal) {
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';
  -webkit-transform: scale(-1, 1);
  transform: scale(-1, 1);
}

:host(.fa-flip-vertical) {
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';
  -webkit-transform: scale(1, -1);
  transform: scale(1, -1);
}

:host(.fa-flip-both),
.fa-flip-horizontal:host(.fa-flip-vertical) {
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';
  -webkit-transform: scale(-1, -1);
  transform: scale(-1, -1);
}

:root :host(.fa-rotate-90),
:root :host(.fa-rotate-180),
:root :host(.fa-rotate-270),
:root :host(.fa-flip-horizontal),
:root :host(.fa-flip-vertical),
:root :host(.fa-flip-both) {
  -webkit-filter: none;
  filter: none;
}

:host(.fa-stack) {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

:host(.fa-stack-1x),
:host(.fa-stack-2x) {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

:host(.fa-stack-1x) {
  line-height: inherit;
}

:host(.fa-stack-2x) {
  font-size: 2em;
}

:host(.fa-inverse) {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
:host(.fa-0)::before {
  content: '\e089';
}

:host(.fa-ellipsis)::before {
  content: '\f141';
}

:host(.fa-angle-down)::before {
  content: '\f107';
}

:host(.fa-angle-right)::before {
  content: '\f105';
}

:host(.fa-arrow-turn-down-right)::before {
  content: '\e3d6';
}

:host(.fa-arrow-turn-left-up)::before {
  content: '\e634';
}

:host(.fa-user-group)::before {
  content: "\e603";
}

:host(.fa-list)::before {
  content: '\f03a';
}

:host(.fa-star)::before {
  content: '\f005';
}

:host(.fa-question-circle)::before {
  content: '\f059';
}

:host(.fa-calendar-day)::before {
  content: '\f783';
}

:host(.fa-caret-down)::before {
  content: '\f0d7';
}

:host(.fa-caret-right)::before {
  content: '\f0da';
}

:host(.fa-trash)::before {
  content: '\f1f8';
}

:host(.fa-thumbs-up)::before {
  content: '\f164';
}

:host(.fa-times-circle)::before {
  content: '\f057';
}

:host(.fa-times)::before {
  content: '\f00d';
}

:host(.fa-close)::before {
  content: '\f00d';
}

:host(.fa-circle-info)::before {
  content: '\f05a';
}

:host(.fa-circle-xmark)::before {
  content: '\f057';
}

:host(.fa-magnifying-glass)::before {
  content: '\f002';
}

:host(.fa-check)::before {
  content: '\f00c';
}

:host(.fa-xmark)::before {
  content: '\f00d';
}
:host(.fa-list-tree)::before {
  content: '\e1d2';
}
:host(.fa-code-commit)::before {
  content: '\f386';
}
:host(.fa-rotate-left)::before {
  content: '\f2ea';
}
:host(.fa-angles-left)::before {
  content: '\f100';
}
:host(.fa-angles-right)::before {
  content: '\f101';
}
:host(.fa-square-poll-horizontal)::before {
  content: '\f682';
}
:host(.fa-triangle-exclamation)::before {
  content: '\f071';
}
:host(.fa-info-circle)::before {
  content: '\f05a';
}
:host(.fa-circle-exclamation)::before {
  content: '\f06a';
}
:host(.fa-wand-magic-sparkles)::before {
  content: '\e2ca';
}

:host(.fa-file)::before {
  content: '\f15b';
}

:host(.fa-upload)::before {
  content: '\f093';
}

:host(.fa-video)::before {
  content: '\f03d';
}

:host(.fa-user)::before {
  content: '\f007';
}

:host(.far),
:host(.fa-regular) {
  font-family: 'Font Awesome 7 Pro';
  font-weight: 400;
}

:host(.fas),
:host(.fa-solid) {
  font-family: 'Font Awesome 7 Pro';
  font-weight: 900;
}
